import { mat3 } from 'gl-matrix'
import { Matrix, Sprite } from 'pixi.js'

export class utils {

  static createSprite(name){
    const texture = game.getTextureFromAtlases(name)
    const sprite = new Sprite(texture)
    sprite.anchor.set(0.5)
    return sprite
  }

  /** Change parent for  PIXI display object
   * @param o display object
   * @param parent new parent
   */
  static  changeParent(o, parent, applyTransform = true) {
    const updateTransform = () => {
      o.updateTransform()
    }

    const updateParent = () => {
      const oMatrix = o.worldTransform.toArray()
      const parentMatrix = parent.worldTransform.toArray()
      const tmpMatrix = mat3.create()
      mat3.invert(tmpMatrix, parentMatrix)
      mat3.mul(tmpMatrix, oMatrix, tmpMatrix)
      const rMatrix = Matrix.IDENTITY
      rMatrix.fromArray(tmpMatrix)
      parent.addChild(o)
      o.transform.setFromMatrix(rMatrix)
      o.updateTransform()
    }

    applyTransform && updateTransform()
    updateParent()
    updateParent()
  }

  /** Change parent for  PIXI display object
   * @param coordinates array
   * @param smoothing smoothing
   * example:
   * const coordinates = [{x: 0, y: 0}, {x: 2, y: 2}, {x: 4, y: 4}, {x: 6, y: 6}, {x: 8, y: 8}, {x: 10, y: 10}];
   * const smoothing = 0.2;
   * const smoothedCoordinates = smoothCoordinates(coordinates, smoothing);
   */
  static smoothCoordinates(coordinates, smoothing) {
    const smoothedCoordinates = []
    for (let i = 0; i < coordinates.length - 1; i++) {
      const startX = coordinates[i].x
      const startY = coordinates[i].y
      const endX = coordinates[i + 1].x
      const endY = coordinates[i + 1].y
      const distanceX = endX - startX
      const distanceY = endY - startY
      const controlPoint1X = startX + distanceX * smoothing
      const controlPoint1Y = startY + distanceY * smoothing
      const controlPoint2X = endX - distanceX * smoothing
      const controlPoint2Y = endY - distanceY * smoothing
      for (let t = 0; t <= 1; t += smoothing) {
        const x = startX * Math.pow(1 - t, 3) + controlPoint1X * 3 * t * Math.pow(1 - t, 2) + controlPoint2X * 3 * Math.pow(t, 2) * (1 - t) + endX * Math.pow(t, 3)
        const y = startY * Math.pow(1 - t, 3) + controlPoint1Y * 3 * t * Math.pow(1 - t, 2) + controlPoint2Y * 3 * Math.pow(t, 2) * (1 - t) + endY * Math.pow(t, 3)
        smoothedCoordinates.push({ x: x, y: y })
      }
    }
    smoothedCoordinates.push(coordinates[coordinates.length - 1])
    return smoothedCoordinates
  }

}
